export enum ParagraphSize {
    BIG = 'big',
    NORMAL = 'normal',
}
